import React from 'react';
import { useLocation, useHistory } from 'react-router-dom'; // Use useHistory instead of useNavigate
import { PaginationPropTypes } from '../../../core/propTypes/gridPropTypes';

const Pagination = React.memo(({ currentPage, pageCount, onPageChange }) => {
    const location = useLocation();

    const handlePageChange = (page) => {
        const params = new URLSearchParams(location.search);
        params.set('page', page);
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top of the page
        onPageChange(page); // Trigger the callback to update the state
    };

    return (
        <div className="ltn__pagination-area text-center">
            <div className="ltn__pagination">
                <ul>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); handlePageChange(1); }}>
                            <i className="fas fa-angle-double-left" />
                        </a>
                    </li>
                    {[...Array(pageCount)]?.map((_, i) => (
                        <li key={i + 1} className={currentPage === i + 1 ? 'active' : ''}>
                            <a href="#" onClick={(e) => { e.preventDefault(); handlePageChange(i + 1); }}>
                                {i + 1}
                            </a>
                        </li>
                    ))}
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); handlePageChange(pageCount); }}>
                            <i className="fas fa-angle-double-right" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
});

Pagination.propTypes = PaginationPropTypes;

export default Pagination;
